import s from './Breadcrumbs.module.scss';
import {TBreadcrumb, TBreadcrumbsProps} from "@/app/[locale]/common/components/Breadcrumbs/types";
import {Crumb} from "@/app/[locale]/common/components/Breadcrumbs/Crumb";
import {APP_ROUTES, GLOBAL_LABELS, INDEX_COUNT} from "../../constants/app";

export const Breadcrumbs = ({ crumb }: TBreadcrumbsProps) => {
    const lastIndex = crumb.length - INDEX_COUNT.ONE;

    return (
        <div className={s.breadcrumbs}>
            <Crumb title={GLOBAL_LABELS.HOME} href={APP_ROUTES.MAIN} active={false} />
            {
                crumb.map((item: TBreadcrumb, index: number) => (
                    <Crumb key={index} title={item.title} href={item.href} active={lastIndex === index} />
                ))
            }
        </div>
    );
};